import React, { useEffect, useState } from 'react';
import { getVimeoVideoJson } from '../../../../model/post';
import { VimeoPlayer } from '../../index';

const VimeoVideo = ({ videoCode, onClose }) => {
  const [episodeTitle, setEpisodeTitle] = useState('');
  const [episodeAuthor, setEpisodeAuthor] = useState('');
  const [episodeDuration, setEpisodeDuration] = useState('');

  useEffect(() => {
    getVimeoVideoJson(videoCode)
      .then((response) => {
        setEpisodeTitle(response?.title);
        setEpisodeAuthor(response?.author_name);
        setEpisodeDuration(response?.duration);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [videoCode]);

  return (
    <div className="article-video-iframe">
      <VimeoPlayer
        videoCode={videoCode}
        videoTitle={episodeTitle}
        videoAuthor={episodeAuthor}
        videoDuration={episodeDuration}
        onClose={onClose}
      />
      <div className="article-video-iframe__backdrop" />
    </div>
  );
};

export default VimeoVideo;
